export default __webpack_public_path__ + "static/media/bg_overview.5d72381d.png";